import api from "./api";

export const fetchDemandForecast = async (days = 7) => {
    try {
        const res = await api.get(`/demand-forecast/predict/${days}`);

        return res.data?.predictions ?? [];
    } catch (err) {
        console.error("Error fetching demand forecast:", err);

        const message =
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err.message ||
            "Failed to fetch demand forecast";

        throw new Error(message);
    }
};

export default {
    fetchDemandForecast,
};